import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DistributionMounth from '../DistributionFunctions/distributionMonth';

import Button from '@mui/material/Button';

export default function SimpleAccordion() {

const ExportBtn = () => {
    return <div style={{
        height: 'auto', display: 'flex',  alignItems: 'center', justifyContent: 'flex-start', alignContent: 'center',
        borderTopLeftRadius: 5, borderTopRightRadius: 5, paddingLeft: 20, paddingTop: 20
      }}>
         <Button color="primary">Exportar</Button>
      </div>
}

    return (
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>
                        Distribución por Mes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <DistributionMounth />
                    
                    {ExportBtn()}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Distribución por Semana</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <DistributionMounth />
                
                {ExportBtn()}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Distribución por Día</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <DistributionMounth />
               
                {ExportBtn()}
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Distribución por Hora</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <DistributionMounth />
                
                {ExportBtn()}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
